var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import ClientService from '../../api/ClientService';
import SystemSettingsService from '../../api/SystemSettingsService';
import { Loading } from 'element-ui';
import ShopDialog from './ShopDialog.vue';
import AddShopDialog from './AddShopDialog.vue';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import { UrlHelper } from '../../helper/UrlWrapper';
import GlobalVue from "../../globalVue";
import ImportData from "../../components/dataActions/ImportData.vue";
import AddSaleMan from "./components/AddSaleMan.vue";
import LogisticsManageDialog from "./components/LogisticsManageDialog.vue";
import SaleManDetail from "./SaleManDetail.vue";
var SupplierGoods = (function (_super) {
    __extends(SupplierGoods, _super);
    function SupplierGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.keyword = '';
        _this.systemSetting = '';
        return _this;
    }
    SupplierGoods.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 445;
        }, 300);
        this.service = ClientService.getInstance();
        this.systemSettingsService = SystemSettingsService.getInstance();
        this.getSupplierConfigdetail();
        this.getSupplierShops();
    };
    SupplierGoods.prototype.lookDetail = function (row, power) {
        var newRow = row;
        newRow.power = power;
        GlobalVue.$emit('addTab', {
            component: SaleManDetail,
            title: '查看绑定用户',
            showExist: false,
            name: 'bind-sale-detail',
            cprops: {
                rowData: newRow,
                isOpenApAccountTypeBusiness: this.isOpenApAccountTypeBusiness,
            },
        });
    };
    SupplierGoods.prototype.exportShop = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择门店！');
            return;
        }
        var shop_ids = this.selectRows.map(function (item) { return item.shop_id; });
        var url = "supplierclientapi/shop/shop_export";
        url = UrlHelper.addParam(url, 'token', this.user.token);
        url = UrlHelper.addParam(url, 'supplier_to_business_id', this.supplierToBusinessId);
        url = UrlHelper.addParam(url, 'shop_ids', shop_ids.join(','));
        location.href = url;
        window._czc.push(['_trackEvent', '客户门店', '客户门店导出']);
    };
    SupplierGoods.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    SupplierGoods.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.systemSettingsService.getSupplierConfigdetail({}).then(function (res) {
            if (res.data && res.data.success) {
                _this.systemSetting = res.data.data;
            }
        });
    };
    SupplierGoods.prototype.getSupplierShops = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = Object.assign({
            business_id: this.businessId,
            supplier_to_business_id: this.supplierToBusinessId,
            keyword: this.keyword,
            sort_field: this.order ? 'shop_pinyin' : null,
            sort_type: this.order ? this.order[1] : null
        }, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getSupplierShops(params).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total || 0;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    SupplierGoods.prototype.pageChange = function (pager) {
        this.getSupplierShops(pager);
    };
    SupplierGoods.prototype.edit = function (shop) {
        var _this = this;
        var instance = this.$dialog(ShopDialog, {
            data: {
                shop: shop,
                clientDetail: this.clientDetail
            }
        }, {
            title: "编辑门店",
            width: 600,
            height: 410
        }).instance;
        instance.$on("editShopInfo:ok", function () {
            _this.getSupplierShops(_this.$refs.pagination.pager);
        });
    };
    SupplierGoods.prototype.getSelectIds = function () {
        var shop_ids = this.selectRows.map(function (item) { return item.shop_id; });
        console.log(888, shop_ids);
        return shop_ids;
    };
    SupplierGoods.prototype.bindSaleMan = function (row) {
        var _this = this;
        if (row == 2) {
            if (!this.selectRows || !this.selectRows.length) {
                this.$message.error('请先选择门店！');
                return true;
            }
        }
        var shop_ids = row && row.shop_id ? row.shop_id : this.getSelectIds().join(',');
        var dialog = this.$dialog(AddSaleMan, {
            data: {
                shopId: shop_ids,
                multiple: !row.shop_id && this.getSelectIds().length > 1 ? true : false,
            }
        }, {
            title: "选择用户",
            width: 700,
            height: 500
        });
        dialog.instance.$on("save:ok", function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                shop_ids: res.shopId,
                account_ids: res.data.toString()
            };
            _this.service.bindStore(params).then(function (res) {
                console.log(res.data);
                loadingInstance.close();
                _this.getSupplierShops();
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                loadingInstance.close();
            });
            dialog.instance.close();
        });
    };
    SupplierGoods.prototype.addShop = function () {
        var _this = this;
        console.log(this.clientDetail);
        var instance = this.$dialog(AddShopDialog, {
            data: {
                clientDetail: this.clientDetail
            }
        }, {
            title: "添加门店",
            width: 600,
            height: 410
        }).instance;
        instance.$on("addShop:ok", function () {
            _this.getSupplierShops(_this.$refs.pagination.pager);
        });
    };
    SupplierGoods.prototype.deleteShop = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择门店！');
            return;
        }
        if (this.selectRows.length > 1) {
            this.$message.error('最多选择一个门店！');
            return;
        }
        this.$confirm('删除门店后，将无法处理该门店的单据，请确定是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                _this.service.deleteShop({
                    supplier_to_shop_id: _this.selectRows[0].supplier_to_shop_id
                }).then(function (res) {
                    if (res.data.success) {
                        if (res.data.code == 30) {
                            var instance = _this.$dialog(ArtMsglist, {
                                data: {
                                    msgData: res.data.data
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                            instance.$on("addClient:ok", function (data) { });
                        }
                        else {
                            _this.$message.success('删除成功！');
                            _this.getSupplierShops();
                        }
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
        });
    };
    SupplierGoods.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    SupplierGoods.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            if (prop == 'order_status_name') {
                prop = 'order_status';
            }
            this.order = [prop, order === 'ascending' ? 'ASC' : 'DESC'];
        }
        this.getSupplierShops();
    };
    SupplierGoods.prototype.search = function () {
        this.getSupplierShops();
    };
    SupplierGoods.prototype.openLogisticsManage = function () {
        var _this = this;
        var instance = this.$dialog(LogisticsManageDialog, {
            data: {
                clientDetail: this.clientDetail
            }
        }, {
            title: "配送物流管理",
            width: 800,
            height: 600
        }).instance;
        instance.$on("refresh:ok", function () {
            _this.getSupplierShops(_this.$refs.pagination.pager);
        });
    };
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], SupplierGoods.prototype, "businessId", void 0);
    __decorate([
        Prop({
            default: '',
            type: String
        })
    ], SupplierGoods.prototype, "supplierToBusinessId", void 0);
    __decorate([
        Prop({})
    ], SupplierGoods.prototype, "fromSystem", void 0);
    __decorate([
        Prop({})
    ], SupplierGoods.prototype, "clientDetail", void 0);
    __decorate([
        Prop({})
    ], SupplierGoods.prototype, "isShowSalesMan", void 0);
    __decorate([
        Prop({})
    ], SupplierGoods.prototype, "isOpenApAccountTypeBusiness", void 0);
    SupplierGoods = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            components: {
                'import-data': ImportData,
            },
        })
    ], SupplierGoods);
    return SupplierGoods;
}(Vue));
export default SupplierGoods;
